import React, { useId, useMemo } from 'react';

import { BgRect, Diagonal, VARIANTS } from './FallbackCardSvgParts';

const FallbackCard = ({ variant = 0, title = '暂无标题', maxLength = 15, className = '', ...props }) => {
  const reactId = useId();
  const idPrefix = useMemo(() => `fallback-card-${reactId.replace(/[:]/g, '')}`, [reactId]);
  const maskId = `${idPrefix}-mask`;
  const { color, icon: Icon } = VARIANTS[variant % VARIANTS.length];

  // Process title: 
  // 1. Prefix with '#'
  // 2. If length > maxLength, truncate to maxLength chars and add '······'
  // 3. If length <= maxLength, just display as is
  const displayTitle = title.length > maxLength 
    ? `#${title.slice(0, maxLength)}······`
    : `#${title}`;

  return (
    <div className={`relative overflow-hidden bg-black select-none ${className}`} {...props}>
      <svg 
        viewBox="0 0 196 268" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        className="w-full h-full absolute inset-0"
        preserveAspectRatio="xMidYMid slice"
      >
        <mask id={maskId} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="196" height="268">
          <BgRect />
        </mask>
        <g mask={`url(#${maskId})`}>
          <BgRect />
          <Diagonal color={color} />
          <Icon idPrefix={idPrefix} />
        </g>
      </svg>
      
      {/* HTML Text Overlay */}
      <div 
        className="absolute left-[28px] top-[78px] right-[24px] text-black font-['OPPOSans'] text-[28px] leading-[1.32] font-bold break-words whitespace-pre-wrap line-clamp-3"
        style={{ fontFamily: 'OPPOSans, sans-serif' }}
      >
        {displayTitle}
      </div>
    </div>
  );
};

export default FallbackCard;
